/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (PIN Lists)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Default values and factories for PIN Lists forms.
────────────────────────────────────────────────────────────────*/

import { FormState, PinMember } from '../types';

/**
 * Default form state
 */
export const DEFAULT_FORM_STATE: FormState = {
  name: '',
  description: '',
  enabled: true
};

/**
 * Default PIN member
 */
export const DEFAULT_MEMBER: PinMember = {
  tempId: '',
  pin: '',
  description: '',
  enabled: true
};

/**
 * Get default form state
 */
export function getDefaultFormState(): FormState {
  return { ...DEFAULT_FORM_STATE };
}

/**
 * Create temporary ID for new members
 */
export function createTempId(prefix: string): string {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

